// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L9zm","colBig":"styles_colBig__3868p","colSmall":"styles_colSmall__2zpsa"};